import React from 'react';
import styled from 'styled-components';

const Pill = props => {
  const { children, fillColor, hoverColor, textColor } = props;

  return (
    <PillWrapper
      fillColor={fillColor}
      hoverColor={hoverColor}
      textColor={textColor}
    >
      {children}
    </PillWrapper>
  );
};

export default Pill;

const PillWrapper = styled.div`
  background-color: ${props => props.theme[props.fillColor]};
  border-radius: 2rem;
  color: ${props => props.theme[props.textColor]};
  padding: 0.5rem 2rem;
  font-size: 14px;

  i {
    margin-right: 8px;
  }

  &:hover {
    background-color: ${props =>
      props.hoverColor
        ? props.theme[props.hoverColor]
        : props.theme[props.fillColor]};
  }
`;
